// Daily Challenge — 3 short missions that refresh at midnight.
// Encourages return visits and gives every session a clear goal.
// Stored locally; counts toward analytics via trackEvent on each tick.

import { trackEvent } from "@/lib/analytics";

const KEY = "we_daily_challenge_v1";

const POOL = [
  // [id, emoji, label, route, predicate(type)]
  { id: "quiz",      emoji: "🧠", label: "Answer 1 quiz",        to: "/quiz",      match: (t) => t === "quiz" || t?.startsWith?.("knowledge:") },
  { id: "color",     emoji: "🎨", label: "Color 1 page",         to: "/coloring",  match: (t) => t === "coloring" },
  { id: "game",      emoji: "🎮", label: "Win 1 game",           to: "/games",     match: (t) => t === "game" || t === "squishy" || t === "snap" },
  { id: "country",   emoji: "🌍", label: "Learn 1 country",      to: "/learn",     match: (t) => t === "learn" || t === "country" },
  { id: "knowledge", emoji: "📚", label: "Try a Knowledge world",to: "/knowledge", match: (t) => typeof t === "string" && t.startsWith("knowledge:") },
  { id: "math",      emoji: "🧮", label: "Do 1 Geo Maths round", to: "/math",      match: (t) => t === "math" || t === "maths-academy" },
  { id: "globe",     emoji: "🌐", label: "Spin the globe",       to: "/globe",     match: (t) => t === "globe" },
];

function todayStr() {
  return new Date().toISOString().slice(0, 10);
}

// Deterministic shuffle so every kid on the same day sees the same 3 missions
// (better for social/sharing — "today's missions"). Seeded by day.
function pickThree(dateStr) {
  let seed = 0;
  for (let i = 0; i < dateStr.length; i++) seed = (seed * 31 + dateStr.charCodeAt(i)) | 0;
  const arr = POOL.slice();
  for (let i = arr.length - 1; i > 0; i--) {
    seed = (seed * 1103515245 + 12345) & 0x7fffffff;
    const j = seed % (i + 1);
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr.slice(0, 3);
}

export function loadDaily() {
  const today = todayStr();
  let state;
  try { state = JSON.parse(localStorage.getItem(KEY) || "null"); } catch { state = null; }
  if (!state || state.date !== today) {
    const missions = pickThree(today).map((m) => ({ id: m.id, emoji: m.emoji, label: m.label, to: m.to, done: false }));
    state = { date: today, missions, claimed: false };
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch {/* ignore */}
  }
  return state;
}

function save(state) {
  try { localStorage.setItem(KEY, JSON.stringify(state)); } catch {/* ignore */}
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("we-daily-changed"));
  }
}

// Called whenever the kid records an event. Marks any matching mission done.
export function tickDaily(type) {
  const state = loadDaily();
  let changed = false;
  state.missions.forEach((m) => {
    if (m.done) return;
    const def = POOL.find((p) => p.id === m.id);
    if (def && def.match(type)) {
      m.done = true;
      changed = true;
    }
  });
  if (changed) {
    save(state);
    const completed = state.missions.filter((m) => m.done).length;
    trackEvent("daily_mission_done", { completed });
    if (completed === state.missions.length && !state.claimed) {
      state.claimed = true;
      save(state);
      trackEvent("daily_challenge_complete", { date: state.date });
    }
  }
  return state;
}
